export default {
	rs: {
		message: {
			common: {
				errors: {
					phone: 'Format broja mora biti 387xxxxxxxxx ili 0xxxxxxxx.',
					wrongCharacterError: 'Lozinka sadrži jedan ili više nedozvoljenih karaktera.',
					requiredField: 'Polje je obavezno.',
				},
				labels: {
					emailAddress: 'E-mail adresa',
					email: 'E-mail',
					emailForUser: 'Email korisnika',
					password: 'Lozinka',
					phone: 'Broj telefona',
					phonePlaceholder: '0xxxxxxxx',
					smsCode: 'SMS kod',
					firstName: 'Ime',
					lastName: 'Prezime',
					subscriberCode: 'Šifra pretplatnika',
					referenceNumber: 'Poziv na broj',
					active: 'Aktivno',
					priceBannerLabel: 'Rata uređaja',
				},
				button: {
					continue: 'Nastavite',
					sendSms: 'Pošaljite kod',
					resendSms: 'Pošaljite ponovo',
					activate: 'Aktivirajte',
					deactivate: 'Deaktivirajte',
					activatePhone: 'Aktivirajte broj',
					addPhone: 'Dodajte broj',
				},
				notification: {
					successTitle: 'Vaš zahtjev je prihvaćen.',
					smsSuccess: 'SMS kod je uspješno poslan.',
					error: {
						message: 'Došlo je do greške',
						description: 'Molimo pokušajte ponovo.'
					},
					wrongPassword: 'Unijeli ste pogrešnu lozinku.',
					emailExists: 'Već postoji nalog na ovoj e-mail adresi.',
				},
				modal: {
					modalContinue: 'Nastavite',
					modalCancel: 'Nazad'
				},
				tooltip: {
					passwordTitle: 'Lozinka treba da ima najmanje 8 karaktera i ispuni najmanje dva uslova:'
				},
				details: {
					controlText: 'Dodatne informacije'
				},
				myProfile: 'Moj profil',
				logout: 'Odjavite se',
				forgotPassword: 'Zaboravili ste lozinku?',
				userServices: 'Vaše usluge',
				unlimited: 'Neograničeno',
				date: {
					months: ['Januar', 'Februar', 'Mart', 'April', 'Maj', 'Jun', 'Jul', 'Avgust', 'Septembar', 'Oktobar', 'Novembar', 'Decembar'],
				},
				currency: 'KM',
			},
			topNavigation: {
				overview: 'Pregled',
				bills: 'Računi',
				support: 'Podrška',
				apps: 'Aplikacije',
			},
			profileNavigation: {
				linkedAccounts: 'Uvezane usluge',
				changeEmail: 'Promjena e-mail-a mog m:tel naloga',
				changePassword: 'Promjena lozinke',
				deleteAccount: 'Brisanje mog m:tel naloga'
			},
			navigation: {
				addServiceBtn: 'Uvežite uslugu',
			},
			login: {
				title: 'Prijavite se na svoj nalog',
				remember: 'Zapamti me',
				forgot: 'Zaboravljena lozinka',
				register: 'Prijavite se',
				footerRegister: [ 'Nemate nalog na moj.mtel.ba?', 'Registrujte se' ],
				additionalInfo: 'Za pomoć oko prijave i registracije na portal pozovite 0800 50 000.',
			},
			registration: {
				backToLogin: 'Nazad na prijavu',
				mobile: {
					header: 'Za korisnike m:tel mobilne telefonije (rezidencijalni korisnici)',
					description: 'Preko m:tel mobilnog broja',
					phone: 'Broj telefona',
					smsCode: 'SMS kod',
					sendSms: 'Pošaljite kod',
					resendSms: 'Pošaljite ponovo'
				},
				fixed: {
					header: 'Za korisnike m:tel fiksnih usluga (paketi, televizija, internet, telefonija)',
					description: 'Preko {subscriberCode} i {referenceNumber} koji možete pronaći na Vašem m:tel računu',
					descriptionSubscriberCode: 'šifre pretplatnika',
					descriptionReferenceNumber: 'poziva na broj',
					subscriberCodeTooltip: 'U ovo polje se upisuje šifra pretplatnika koja se nalazi na vašem računu.',
					referenceNumberTooltip: 'U ovo polje se upisuje poziv na broj koji se nalazi na vašem računu.',
				},
				dividerText: 'Ili',
				modals: {
					b2b: {
						title: 'Preuzmite m:GO aplikaciju!',
						description: 'Vaš broj pripada poslovnoj grupi i neophodno je da preuzmete m:GO aplikaciju da biste upravljali brojem.',
					},
					notFound: {
						title: 'Broj sa kojim ste se pokušali registrovati nije pronađen u m:tel mreži.',
						description: 'Prelaskom na m:tel mrežu možete uživati u mnogim pogodnostima – besplatnim razgovorima, mnoštvu mobilnog interneta u paketu, odličnim izborom mobilnih telefona na rate bez kamate i još mnogo toga.',
						submitBtn: 'Posjetite m:tel sajt'
					}
				},
			},
			createAccount: {
				header: 'Kreiranje naloga',
				subtitle: 'Unesite vaše podatke kako bismo mogli da Vam kreiramo nalog',
				mandatoryField: 'Ovo polje je obavezno.',
				wrongEmail: 'Unesite e-mail u ispravnom formatu.',
				minLengthError: 'Lozinka mora imati najmanje 8 karaktera.',
				maxLengthError: 'Lozinka mora imati najviše 64 karaktera.',
				bigLetter: 'Veliko slovo',
				smallLetter: 'Malo slovo',
				number: 'Broj',
				specialChar: 'Simbol',
				confirmed: 'Lozinke se ne poklapaju.',
				conditionsError: 'Potrebno je ispuniti bar dva uslova.',
				repeatPassword: 'Potvrdite lozinku',
				createAccount: 'Kreiraj nalog',
				backToRegistration: 'Nazad na registraciju',
			},
			registrationConfirmationPage: {
				title: 'E-mail potvrda',
				description: 'Poslali smo Vam e-mail na {email} u kojem možete pronaći LINK za aktivaciju naloga. Ukoliko ga ne možete pronaći u inbox-u, provjerite spam folder ili pošaljite zahtjev ponovo.',
				button: 'Pošaljite ponovo',
				emailIsSentDescription: 'Poslali smo Vam email na {email} sa linkom za aktivaciju naloga.',
				durationOfActivationLink: 'Link za aktivaciju naloga važi {linkDuration}h.',
			},
			passwordConfirmationPage: {
				description: 'Poslali smo email na {email} sa linkom za promjenu lozinke. Ako ga ne možete pronaći u inbox-u, pogledajte SPAM folder ili ponovo pošaljite Zahtjev.',
				button: 'Pokušajte ponovo',
				emailIsSentDescription: 'Poslali smo Vam email na {email} sa linkom za promjenu lozinke.',
				durationOfActivationLink: 'Link za promjenu lozinke važi 30 minuta.',
			},
			linkExpired: {
				title: 'Vaš link je istekao.',
				description: 'Trajanje linka je ograničeno na 24h. Ukoliko u tom vremenu ne potvrdite nalog, neophodno je ponovo pokrenuti proces registracije.',
				button: 'Pokrenite ponovo'
			},
			forgotPassword: {
				title: 'Zaboravili ste lozinku?',
				description: 'Unesite svoju e-mail adresu u polje i poslaćemo Vam link za promjenu zaboravljene lozinke.',
				backButton: 'Nazad na prijavu',
				submitButton: 'Pošaljite'
			},
			forgotPasswordLinkExpired: {
				title: 'Link za promjenu lozinke je istekao!',
				description: 'Važenje linka je 30 minuta. Ako i dalje želite promjeniti lozinku, pokrenite ponovo proces promjene.',
				button: 'Pokrenite ponovo'
			},
			createNewPassword: {
				title: 'Kreirajte novu lozinku',
				description: 'Lozinka treba da ima najmanje 8 karaktera i ispuni najmanje 2 uslova: veliko slovo, malo slovo, broj, simbol.',
				newPassword: 'Nova lozinka',
				repeatPassword: 'Potvrdite lozinku',
				saveButton: 'Sačuvajte lozinku'
			},
			passwordChanged: {
				title: 'Uspješno ste promijenili lozinku!',
				description: 'Nastavite sa prijavom na Moj m:tel portal.',
				signInButton: 'Prijavite se'
			},
			accountExists: {
				title: 'Pronađena usluga',
				subtitle: 'Usluga je već registrovana na moj m:tel nalogu: {email}. Odaberite opciju:',
				loginWithEmail: 'Uloguj me sa',
				registerServiceOnNewAccount: 'Registruj ovu uslugu na novi nalog',
				useExistingAccount: 'Unosom lozinke pristupićete Moj m:tel nalogu.',
				accountUnlinkedFromEmail: 'Ovaj nalog će Vam biti razvezan sa {email}.',
				enterPasswordFromOldAccount: 'Unesite lozinku postojećeg naloga iz kojeg želite ukloniti uslugu.',
				createNewAccount: 'Kreirajte novi nalog.',
				forgotPassword: 'Zaboravljena lozinka?',
				login: 'Uloguj se',
				continue: 'Nastavite',
				cantRemoveService: 'Nije moguće ukloniti uslugu sa datog naloga.',
				chooseFirst: 'Izaberite prvu opciju i ulogujte se sa postojećim nalogom.',
				getInfo: 'Za pomoć oko registrovanja na portal pozovite 0800 50 000 ili pošaljite mejl na korisnicka.podrska@mtel.ba.'
			},
			accountsList: {
				mainAccount: 'Osnovni nalog/uvezana usluga',
				linkedAccounts: 'Uvezane usluge',
				removeAccountButton: 'Uklonite uvezanu uslugu',
				removeAccountModalTitle: 'Da li ste sigurni da želite da uklonite uvezanu uslugu?',
				removeAccountModalDescription: 'Uklanjanjem uvezane usluge pristup pregledu resursa i ostalim benefitima neće biti dostupan.',
				removeAccountModalSubmit: 'Uklonite uslugu',
				successNotification: 'Nalog je uspješno uklonjen.',
				errorNotificationDescription: 'Molimo pokušajte ponovo. Nije moguće ukloniti glavni Moj m:tel nalog. Za više informacija pozovite besplatni broj korisničke podrške 0800 50 300.'
			},
			changeEmail: {
				title: 'Promjena e-mail adrese',
				emailFieldLabel: 'Nova e-mail adresa',
				passwordFieldLabel: 'Vaša lozinka',
				submitButtonText: 'Izmjenite e-mail',
				modalTitle: 'E-mail potvrda',
				modalDescription: 'Poslali smo e-mail na {email} sa linkom za promjenu e-mail adrese. Ako ga ne možete pronaći u inbox-u, pogledajte SPAM folder ili ponovo pošaljite Zahtjev.',
				modalSubmit: 'Pokušajte ponovo',
				notificationSuccess: 'Uspješno ste promijenili e-mail adresu.',
				linkExpiredTitle: 'Vaš link je istekao.',
				linkExpiredDescription: 'Ako i dalje želite promjeniti e-mail adresu, pokrenite ponovo proces promjene.',
				linkExpiredSubmit: 'Pokrenite ponovo',
				notificationDescription: 'Poslali smo Vam email na {email} sa linkom za promjenu e-mail adrese.',
			},
			changePassword: {
				title: 'Promjena lozinke',
				description: 'Lozinka treba da ima najmanje 8 karaktera i ispuni najmanje 2 uslova: veliko slovo, malo slovo, broj, simbol',
				oldPassword: 'Vaša lozinka',
				newPassword: 'Nova lozinka',
				confirmPassword: 'Potvrdite lozinku',
				submitButtonText: 'Sačuvajte lozinku',
				usernameError: 'Lozinka ne sme da sadrži Vaše korisničko ime.',
				modalTitle: 'Da li ste sigurni da želite izmjeniti lozinku?',
				modalDescription: 'Promjenjenu lozinku koristite prilikom prijave.',
				modalSubmit: 'Sačuvajte izmjene',
				notificationSuccess: 'Lozinka je uspješno promjenjena.'
			},
			deleteAccount: {
				title: 'Brisanje Moj m:tel naloga',
				description: 'Brisanjem prestajete koristiti Moj m:tel nalog i morate se ponovo registrovati.',
				submitButtonText: 'Obrišite nalog',
				modalTitle: 'Da li ste sigurni da želite da obrišete Moj m:tel nalog?',
				modalDescription: 'Brisanjem prestajete koristiti Moj m:tel nalog i morate se ponovo registrovati.',
				modalSubmit: 'Obrišite nalog'
			},
			addService: {
				mainTitle: 'Izaberite uslugu koju želite dodati',
				existsTitle: 'Pronađena usluga',
				connectTitle: 'Pronađena usluga',
				mobileSubTitle: 'Mobilna usluga',
				fixedSubTitle: 'Fiksna usluga',
				tabsItemsTitles: [ 'Mobilna usluga', 'Fiksna usluga' ],
				existDescriptionPart1: 'Usluga je već uvezana na nalogu {email}. Ukoliko želite da premjestite uslugu na trenutni nalog, potrebno je da unesete lozinku gore pomenutog naloga.',
				existDescriptionPart2: 'Unosom lozinke usluga će biti uklonjena sa naloga {email} i biće dodata na Vaš trenutni nalog.',
				connectDescription: 'Uspješno ste uvezali uslugu na vaš nalog. Ovde možete promjeniti vaše ime i prezime.',
				notificationSuccess: 'Uspješno ste dodali novu uslugu.',
				modalBackButton: 'Korak nazad',
			},
			topUp: {
				title: 'Online dopuna',
				tabsItemsTitles: [ 'Platna kartica', 'Prenesi dopunu', 'M:bon dopuna' ],
				tabsPostpaidItemsTitles: [ 'Platna kartica', 'Zaduživanjem računa', 'M:bon dopuna' ],
				tabsKombinujItemsTitles: [ 'Platna kartica', 'M:bon dopuna' ],
				tabsAdditiveNetItemsTitles: [ 'Platna kartica', 'M:bon dopuna' ],
			},
			topUpMBon: {
				description: 'm:bon - nov način dopune ili plaćanja računa. Posjetite sajt i saznajte više.',
				buttonRedirect: 'Saznajte više',
			},
			topUpDebit: {
				phoneLabel: 'Dopuna broja',
				chooseAmount: 'Odaberite željenu dopunu',
				autoPaidCheckboxLabel: 'Želim da uključim automatsku dopunu broja svakih 30 dana.',
				submitButton: 'Aktivirajte dopunu',
				automaticTopups: 'Aktivne dopune ',
				automaticTopupsTableHeader: [ 'Broj telefona', 'Iznos dopune', 'Datum aktivacije' ],
				modalTitle: 'Da li ste sigurni da želite aktivirati dopunu?',
				additionalInfo: 'Aktivirane dopune se automatski aktiviraju na svakih 30 dana.',
				modal: {
					title: 'Da li ste sigurni da želite aktivirati dopunu?',
					description: 'Broj telefona {msisdn} će biti dopunjen sa iznosom od {topUpAmount} KM.',
					submitButton: 'Aktivirajte dopunu',
				},
				modalSuccess: {
					title: 'Uspješno ste aktivirali dopunu!',
					description: 'Broj telefona {msisdn} je dopunjen sa iznosom od {topUpAmount} KM.'
				},
				modalDeactivation: {
					title: 'Da li ste sigurni da želite da deaktivirate dopunu računa?',
					description: 'Za broj telefona {msisdn} će biti deaktivirana automatska dopuna.',
					submitButton: 'Deaktivirajte',
				},
				notification: {
					title: 'Vaš zahtjev je prihvaćen. ',
					description: 'Automatska dopuna je uspješno deaktivirana.'
				}
			},
			topUpCredit: {
				phoneFieldPlaceholder: 'Unesite broj',
				supplementFieldPlaceholder: 'Unesite iznos',
				supplementFieldLabel: 'Iznos dopune',
				additionalInfo: 'Iznos dopune može biti do 1,99 KM. Moguće je dopuniti samo Dopuna (prepaid) broj iz m:tel mreže sa stanjem računa manjim od 2KM. Mjesečni limit dopune je 40KM.',
				submitButton: 'Uplatite dopunu',
				modalActivation: {
					title: 'Da li ste sigurni da želite da zadužite račun?',
					description: 'Broj telefona {msisdn} će biti dopunjen sa iznosom od {amount} KM.',
					submitButton: 'Uplatite',
				},
				modalSuccess: {
					title: 'Uspješno ste dopunili kredit',
					description: 'Broj telefona {msisdn} je dopunjen sa iznosom od {amount} KM.',
				},
			},
			overviewHeader: {
				balance: 'Stanje glavnog računa:',
				balancePostpaid: 'Trenutno stanje računa:',
				expiryDateSupplement: 'Istek dopune:',
				expiryDateContract: 'Istek ugovora:',
				balanceTooltipPostpaid: 'U iznos trenutnog stanja računa nije uključen neobrađen roming saobraćaj, pripadajući bonus i PDV.',
			},
			changeTariff: {
				noticeText: 'Prva promjena tarife je besplatna, a svaka naredna se naplaćuje 1,00KM sa PDV-om.',
				buttonApply: 'Aktivirajte tarifu',
				notificationSuccess: 'Vaš zahtjev je prihvaćen. Uspješno ste prešli na tarifu {tariff}.',
				modalTitle: 'Da li ste sigurni da želite promjeniti tarifu?',
				modalDescription: 'Vaša tarifa će biti promenjena u {tariff}. Prva promjena tarife je besplatna, a svaka naredna se naplaćuje 1,00KM sa PDV-om.'
			},
			mobilePrepaidOverview: {
				additionalInfo: 'Prikaz resursa je za saobraćaj ostvaren od trenutka aktivacije tarifne opcije/dodatka.',
				additionalInfoWithoutTariffPlan: 'Prikaz resursa je za saobraćaj ostvaren od trenutka aktivacije tarifne opcije/dodatka.',
				bonusesTitle: 'Vaši bonusi',
				bonusesIncludedInOptionsTitle: 'Bonusi uključeni u tarifne opcije',
				tariffOptionExpirationDate: 'Tarifna opcija važi do',
			},
			mobilePostpaidOverview: {
				listActivatedTariffAddonsSubTitle: 'Aktivirani dodaci',
				listActivatedTariffAddonsTitles: [ 'Naziv', 'Cena', 'Datum aktivacije', 'Datum obnove' ],
				additionalInfo: 'Prikaz bonusa uključenih u pretplatu je za tekući mjesec. Bonus internet se obnavlja svakog prvog dana u mjesecu.',
				resourcesTitle: 'Bonusi uključeni u pretplatu',
				bonusesIncludedInOptionsTitle: 'Bonusi uključeni u tarifne opcije',
				installmentsTitle: 'Rate za uređaj',
				installmentsTotalAmountTitle: 'Preostali iznos',
				installmentsExpiredDateTitle: 'Period otplate',
				installmentsCurAmountTitle: 'Tekuća rata',
				installmentsMonthAmountTitle: 'Broj neplaćenih rata',
				unlimitedTooltip: {
					MIN: 'Neograničeni razgovori podrazumijevaju fair use princip sa 3000 min. razgovora prema m:tel mreži u Pretplata: S+, a 3000 min. razgovora prema svim mrežama u BiH u Pretplata: M+, 5000 min. razgovora prema svim mrežama u BiH u Pretplata: L+ i 10000 min. razgovora prema svim mrežama u Pretplata: XXL+ tarifi.',
					SMS: 'Neograničen SMS podrazumijeva fair use princip sa 1000 SMS-ova, osim Pretplata: XXL+ tarife u kojima je iznos SMS poruka 5000.',
				}
			},
			tariffDeactivation: {
				modalTitle: 'Da li ste sigurni da želite deaktivirati {tariffName} tarifni plan?',
				modalDescription: 'Deaktivacijom plana gubite resurse iz {tariffName} tarifnog plana.',
				modalSubmit: 'Deaktivirajte',
				notificationDescription: 'Uspješno ste deaktivirali tarifni plan {tariffName}.',
			},
			tariffActivation: {
				activeTariffTitle: 'Isplaniraj komunikaciju uz Dopuna tarifne planove',
				modalTitle: 'Da li ste sigurni da želite da aktivirate {tariffName} tarifni plan?',
				modalDescription: 'Aktivacija {tariffName} tarifnog plana će Vam biti naplaćena po cjeni od {tariffPrice} KM.',
				buttonActiveTariff: 'Aktivirajte',
				notificationDescription: 'Uspješno ste aktivirali tarifni plan {tariffName}.',
			},
			gracePeriod: {
				title: 'Trajanje vašeg računa je isteklo!',
				description: 'Produžite period važenja Vašeg glavnog računa kupovinom tarifne opcije od 0.5KM i Vaš račun će biti produžen za 3 dana. Ukoliko u roku od najviše 120 dana, od dana isteka dopune, ne produžite trajanje Vašeg računa broj ulazi u proceduru deaktivacije.',
				submitButtonText: 'Aktivirajte',
				modal: {
					title: 'Da li želite da produžite trajanje glavnog računa?',
					description: 'Tarifna opcija će Vam biti naplaćena 0.5KM sa Vašeg računa.',
					submit: 'Aktivirajte',
				},
				notEnoughMoneyModal: {
					title: 'Vaš zahtjev nije prihvaćen',
				},
				successDescription: 'Uspješno ste produžili trajanje Vašeg računa u trajanju od 3 dana.',
			},
			withoutPrepaidPermissions: {
				title: 'Uslugu nije moguće aktivirati za datog korisnika.',
				description: 'Za više informacija pozovite kontakt centar na 066 10 10 10.',
			},
			tariffOptions: {
				description: 'Aktivirajte tarifne opcije i uživajte u dodatnim minutima, razgovorima, internet i roaming saobraćaju.',
				descriptionPostpaid: 'Aktivirajte tarifne opcije ili planove i uživajte u dodatnim razgovorima, internetu ili roming saobraćaju.',
				descriptionFixTel: 'Aktivirajte tarifne opcije i uživajte u dodatnim minutama i razgovorima.',
				descriptionAdditive: 'Aktivirajte DopunaNET tarifne opcije i uživajte u dodatnom internet saobraćaju.',
				buttonActivate: 'Aktivirajte',
				buttonDeactivate: 'Deaktivirajte',
				buttonActivateUssdSms: 'Kako da aktiviram?',
				renewableTextLabel: 'Aktivirano',
				pendingTextLabel: 'U obradi',
				modalActivateTitle: 'Da li ste sigurni da želite da aktivirate {tariffOptionName}?',
				modalActivateDescription: 'Cijena tarifne opcije/dodatka iznosi {tariffOptionPrice} KM.',
				modalActivateDescriptionFixed: 'Naknada za tarifnu opciju će biti obračunata u punom iznosu za tekući mjesec. Cijena tarifne opcije/dodatka iznosi {tariffOptionPrice} KM.',
				modalDeactivateTitle: 'Da li ste sigurni da želite da deaktivirate {tariffOptionName}?',
				notificationActivateTitle: 'Uspješno ste aktivirali tarifnu opciju.',
				notificationActivateAddonTitle: 'Uspješno ste aktivirali tarifni dodatak.',
				notificationActivateDescription: 'Očekujte i SMS potvrdu aktivacije.',
				notificationDeactivateTitle: 'Vaš zahtjev je prihvaćen.',
				notificationDeactivateDescription: 'Uspješno ste deaktivirali tarifnu opciju.',
				notificationSiguranNetDeactivateDescription: 'Usluga će biti deaktivirana na kraju mjeseca.',
				notificationActivateFixed: {
					title: 'Vaš zahtjev je prihvaćen.',
					description: 'Očekujte aktivaciju u narednih 48h.'
				},
				notificationDeactivateFixed: {
					title: 'Vaš zahtjev je u obradi.',
					description: 'Očekujte deaktivaciju u narednih 48h.'
				},
				subscriptionTerm: 'Trajanje:',
				renewable: 'obnovljivo',
				ussdModalDescription: 'Aktivirajte tarifne opcije putem USSD menija.',
				smsModalDescription: 'Aktivirajte slanjem SMS poruke sadržaja.',
				smsModalDescriptionDivider: 'na'
			},
			additionalServices: {
				title: 'Parking i usluge',
				description: [ 'Usluga Zabrane identifikacije vlastitog broja (CLIR) onemogućava identifikaciju broja korisnika usluge na ekranu aparata pretplatnika kojem je upućen poziv. Aktivacija i korišćenje usluge je besplatna.', 'Usluga Poziv na čekanju omogućava da vidite ko vas zove u toku razgovora sa drugim pozivaocem.' ],
				serviceStatusTexts: [ 'Aktivno', 'Deaktiviran' ],
				serviceStatusButtonsTexts: [ 'Aktivirajte', 'Deaktivirajte' ],
				modalActivateTitle: [ 'Aktivacija usluge Zabrane identifikacije vlastitog broja (CLIR)', 'Aktivacija usluge Poziv na čekanju' ],
				modalDeactivateTitle: [ 'Deaktivacija usluge Zabrane identifikacije vlastitog broja (CLIR)', 'Deaktivacija usluge Poziv na čekanju' ],
				modalActivateDescription: 'Da li ste sigurni da želite aktivirati uslugu?',
				modalDeactivateDescription: 'Da li ste sigurni da želite deaktivirati uslugu?',
				notificationStatusesSuccessNames: [ 'Zabrane identifikacije vlastitog broja.', 'Poziv na čekanju.' ],
				notificationStatusesSuccess: [ 'Uspješno ste aktivirali uslugu ', 'Uspješno ste deaktivirali uslugu ' ],
				textInfo: 'Aktivacija i deaktivacija usluge može potrajati i do 24h. Status usluge će se promjeniti kada zahtjev bude izvršen.'
			},
			firstLogin: {
				title: 'Vaše uvezane usluge',
				description: 'Ukoliko želite da dodate još neke usluge kliknite na "Uvežite uslugu" u dnu strane.',
				buttonAddSevice: 'Uvežite uslugu',
				buttonCancel: 'Nastavite na pregled'
			},
			internetOverview: {
				title: 'Pregled preostalih resursa',
				titleDescription: 'Internet korisničko ime',
				speedometerPreUnit: 'do',
				description: 'Internet korisničko ime je dobro znati u slučaju da Vam zatreba prilikom prijave smetnje telefonskim putem na 080050000.',
				userName: 'Korisničko ime - '
			},
			kombinujOverview: {
				resourcesTitle: 'Bonusi uključeni u Kombinuj pretplatu',
				bonusesIncludedInOptionsTitle: 'Bonusi uključeni u tarifne opcije',
			},
			changeTariffInternet: {
				tariffDescription: 'Podnesite zahtjev za promjenu internet tarife i naš agent prodaje će Vas kontaktirati u najkraćem mogućem roku.',
				buttonApply: 'Podnesite zahtjev',
				modalActivateTitle: 'Da li ste sigurni da želite poslati zahtjev za prelazak na tarifu {tariffOptionName}?',
				modalActivateDescription: 'Nakon poslatog zahtjeva, konktaktiraće Vas m:tel agent radi potvrde uslova prelaska na novu tarifu.',
				buttonActivate: 'Podnesite zahtjev',
				notificationSuccessTitle: 'Zahtjev je uspješno poslan.',
				notificationSuccessDescription: 'Očekujte poziv od strane m:tel agenta.',
				detailsContent: 'Promena tarife ne uključuje aktuelne promocije.',
			},
			accountWithoutCustomers: {
				title: 'Trenutno nemate nijednu uvezanu uslugu na nalogu.',
				description: 'Kako biste nastavili korišćenje moj mtel portala, molimo dodajte uslugu.',
			},
			tvOverview: {
				title: '{label} korisničko ime',
				description: '{label} korisničko ime je dobro znati u slučaju da Vam zatreba prilikom prijave smetnje telefonskim putem na {phone}.',
				userName: 'Korisničko ime - ',
				addonsTableTitle: 'Aktivirani dodaci',
				tvAddonsTitles: [ 'Naziv', 'Datum aktivacije', 'Status' ],
				deactivationModal: {
					title: 'Da li ste sigurni da želite da deaktivirate paket {name}?',
					submitButton: 'Deaktivirajte',
				},
				hboActivationModal: {
					title: 'Želite li aktivirati Max bez dodatne naknade?',
					description: 'Odabirom opcije “Nastavite” bićete preusmjereni na Max sajt, gdje ćete moći završiti proces aktivacije/registracije.',
				},
			},
			changeTariffPostpaid: {
				submitButton: 'Podnesite zahtjev',
				activateTariffModal: {
					title: 'Da li ste sigurni da želite poslati zahjtev za prelazak na tarifu {tariffName}?',
					description: 'Nakon poslanog zahtjeva, kontaktiraće Vas m:tel agent radi potvrde uslova prelaska na novu tarifu. '
				},
				successNotification: {
					title: 'Zahtjev je uspješno poslan.',
					description: 'Očekujte poziv od strane m:tel agenta.'
				},
				noTariffs: {
					title: 'Nema dostupnih tarifa za promjenu',
					description: 'Koristite najvišu tarifu. Hvala Vam na ukazanom poverenju!'
				}
			},
			fixedTelephonyOverview: {
				title: 'Aktivirani dodaci',
				listOfActivatedAddonsHeaders: [ 'Naziv', 'Datum aktivacije', 'Status' ],
				modal: {
					title: 'Da li ste sigurni da želite deaktivirati dodatak {name}?',
					submitButton: 'Deaktivirajte',
				},
				successNotification: {
					title: 'Vaš zahtjev je prihvaćen.',
					description: 'Očekujte aktivaciju u narednih 48h.',
				},
			},
			additiveOverview: {
				bonusesTitle: 'Vaši bonusi',
				bonusesIncludedInOptionsTitle: 'Bonusi uključeni u tarifne opcije',
				emptyBonuses: 'Nemate resursa za prikaz.',
			},
			accountNumbers: {
				tabsItemsTitles: [ 'Omiljeni brojevi', 'Najdraži broj', 'Prijatelj broj' ],
				activeStatus: 'Aktiviran',
				pendingStatus: 'U obradi',
				deactivateOptionButton: 'Deaktivirajte opciju',
				deactivationDescription: 'Nakon deaktivacije gubite pravo na razgovore po cjeni od 0 KM.',
				deactivationSuccessNotificationDescription: '{optionName} je deaktiviran.',
				activateOptionButton: 'Aktivirajte opciju',
			},
			friendsNumbers: {
				description: ['Odaberite „Prijatelj broj“ uslugu i razgovarajte sa dva broja po želji iz bilo koje mobilne ili fiksne mreže u BiH povoljnije. Uključenje jednog „Prijatelj broja“ je besplatno, a svako naredno uključenje ili promjena se naplaćuje 3,51 KM sa PDV-om.', 'Cijena razgovora prema „Prijatelj broju“ za tarifne modele „Standardica“ i „Opuštencija“ iznosi 0,09 KM/min sa PDV-om, a u okviru „XYnet“ tarifnog modela 0,10 KM/min sa PDV-om.'],
				descriptionFixed: 'Korisnici fiksne telefonije imaju pravo na jedan prijatelj broj u m:tel mobilnoj mreži. Promjena broja se ne naplaćuje.',
				descriptionPostpaid: ['Korisnici postpaid tarifnih modela Pretplata Start, Pretplata Plus, Pretplata Plus NET, Pretplata Top, Pretplata Max i Pretplata Premium nemaju mogućnost uključenja Prijatelj broja.'],
				descriptionCombine: ['Tarifni modeli KOMBINUJ Flex/Flat i KOMBINUJ 5 omogućavaju uključenje tri (3) Prijatelj broja iz bilo koje fiksne i mobilne mreže u BiH. Uključenje tri (3) Prijatelj broja i/ili tri (3) promjene Prijatelj broja su besplatne, svako naredno uključenje/promjena se naplaćuje 3,51 KM sa PDV-om.', 'Tarifni model KOMBINUJ:Senior omogućava uključenje jednog (1) Prijatelj broja isključivo iz mobilne mreže Mtela. Promjena prijatelj broja se naplaćuje 5,85 KM sa PDV-om.', 'Tarifni modeli KOMBINUJ: S Junior i Kombinacija nemaju mogućnost uključenja Prijatelj broja.'],
				phoneFieldLabel: 'Dodajte Prijatelj broj',
				activatedNumbersListTitle: 'Lista aktiviranih prijatelj brojeva',
				activatedNumbersListTitleFixed: 'Lista aktiviranih prijatelj brojeva u m:tel mobilnoj mreži',
				addNumberModal: {
					title: 'Da li ste sigurni da želite da dodate Prijatelj broj {msisdn}?',
					description: 'Uklјučenje jednog Prijatelј broja je besplatno, a svako naredno uklјučenje/promjena se naplaćuje u iznosu od 3,51 KM.',
					descriptionCombine: 'Uključenje i/ili tri promjene Prijatelj broja su besplatne, a svako naredno uključenje i/ili promjena se naplaćuje u iznosu od 3,51KM sa PDV-om.',
					descriptionPostpaid: 'Uklјučenje jednog Prijatelј broja je besplatno, a svako naredno uklјučenje/promjena se naplaćuje u iznosu od 5,85 KM sa PDV-om.',
				},
				removeNumberModal: {
					title: 'Da li ste sigurni da želite da obrišete Prijatelj broj {msisdn}?',
					submitButton: 'Obrišite broj'
				},
				editNumberModal: {
					title: 'Da li ste sigurni da želite da izmjenite Prijatelj broj {msisdn}?',
					description: 'Uklјučenje jednog Prijatelј broja je besplatno, a svako naredno uklјučenje/promjena se naplaćuje u iznosu od 3,51 KM.',
					descriptionCombine: 'Uključenje i/ili tri promjene Prijatelj broja su besplatne, a svako naredno uključenje i/ili promjena se naplaćuje u iznosu od 3,51KM sa PDV-om.',
					descriptionPostpaid: 'Uklјučenje jednog Prijatelј broja je besplatno, a svako naredno uklјučenje/promjena se naplaćuje u iznosu od 5,85 KM sa PDV-om.',
					phoneFieldLabel: 'Unesite Prijatelj broj',
					submitButton: 'Izmjenite broj',
				},
				fixedNumberNotificationTitle: 'Vaš zahtjev uspješno poslan.',
				fixedNumberNotificationDescription: 'Očekujte obradu i aktivaciju u što kraćem roku.',
				postpaidNumberNotificationTitle: 'Vaš zahtjev je u obradi.',
				postpaidNumberNotificationDescription: 'Prijatelj broj {msisdn} će biti aktiviran kroz nekoliko minuta.',
				numberAddedNotification: {
					description: 'Uspješno ste dodali broj {msisdn}.'
				},
				numberRemovedNotification: {
					description: 'Uspješno ste izbrisali broj {msisdn}.'
				},
				numberEditedNotification: {
					description: 'Uspješno ste izmenili broj {msisdn}.'
				},
			},
			favouriteNumbers: {
				description: 'Odaberite opciju „Omiljeni brojevi“ i razgovarajte za 0KM sa dva broja po želji iz m:tel fiksne ili mobilne mreže. Opcija se obnavlja automatski svaki mjesec, a cijena uspostave poziva je 0,09 KM sa PDV-om.',
				phoneFieldLabel: 'Dodajte Omiljeni broj',
				activatedNumbersListTitle: 'Lista aktiviranih omiljenih brojeva',
				optionActivatedNotification: {
					description: 'Aktivirali ste uslugu Omiljeni broj i dodali broj {msisdn}. Usluga se automatski obnavlja svakih 30 dana.',
				},
				numberAddedNotification: {
					description: 'Uspješno ste dodali broj {msisdn}.'
				},
				addEnteredNumberModal: {
					title: 'Da li ste sigurni da želite da aktivirate tarifnu opciju Omiljeni broj?',
					description: 'Aktivacija će Vam biti naplaćena po cjeni od {price} KM.',
					phoneFieldLabel: 'Unesite Omiljeni broj',
				},
				addNumberModal: {
					title: 'Da li ste sigurni da želite da dodate Omiljeni broj {msisdn}?',
					description: 'Nakon dodavanja, broj nije moguće izmeniti ili obrisati u toku trajanje tarifne opcije.',
				},
				deactivateOptionModal: {
					title: 'Da li ste sigurni da želite da deaktivirajte tarifnu opciju Omiljeni broj?',
					description: 'Nakon deaktivacije gubite pravo na razgovore po cjeni od 0 KM sa dodatim omiljenim brojevima.',
				},
			},
			dearestNumbers: {
				description: 'Odaberite najdraži broj iz m:tel mobilne mreže za besplatne razgovore u trajanju od 7 dana. Broj je moguće dodati nakon aktivacije tarifne opcije po cijeni od {price} KM sa PDV-om. Tarifna opcija se obnavlja svakih 7 dana, osim u slučaju deaktivacije.',
				activatedNumbersListTitle: 'Aktivirani Najdraži broj',
				optionActivatedNotification: {
					description: 'Aktivirali ste uslugu Najdrazi broj i dodali broj {msisdn}. Usluga se automatski obnavlja svakih 7 dana.',
				},
				addEnteredNumberModal: {
					title: 'Da li ste sigurni da želite da aktivirate tarifnu opciju Najdraži broj?',
					description: 'Aktivacija će Vam biti naplaćena po cjeni od {price} KM.',
					phoneFieldLabel: 'Unesite Najdraži broj',
				},
				deactivateOptionModal: {
					title: 'Da li ste sigurni da želite da deaktivirajte tarifnu opciju Najdraži broj?',
					description: 'Nakon deaktivacije gubite pravo na razgovore po cjeni od 0 KM sa dodatim omiljenim brojevima.',
				},
			},
			combineNumbers: {
				noNumbers: {
					title: 'Uslugu nije moguće aktivirati za datog korisnika.',
					description: 'Za više informacija pozovite kontakt centar na 066 10 10 10.'
				}
			},
			additionalStbDevices: {
				title: 'Dodatni STB uređaj',
				descriptionIPTV: 'Dodatni IPTV prijemnik (Set Top Box) omogućava Vam, pod uslovom da postoje tehnički uslovi, prijem TV programa na dodatnim TV prijemnicima (drugi ili više) istovremeno. Uslove korišćenja možete pronaći na {email}.',
				descriptionMSAT: 'Dodatni m:SAT prijemnik omogućava prijem m:SAT televizije na dodatnom TV prijemniku (dva maksimalno). Uslove korišćenja možete pronaći na {email}. Za više informacija pozovite besplatni broj: 0800 50 905.',
				actionsDescription: 'Podnesite zahtjev za dodjelu ili otkazivanje dodatnog STB-a.',
				addDeviceButton: 'Dodijelite STB',
				removeDeviceButton: 'Otkažite dodatni STB',
				requestsList: {
					title: 'Podnijeti zahtjevi',
					addAdditionalDevice: 'Dodjela dodatnog STB uređaja',
					removeAdditionalDevice: 'Otkazivanje dodatnog STB uređaja',
				},
				modalDescription: 'Nakon poslanog zahtjeva, očekujte obradu u najkraćem mogućem roku.',
				addModal: {
					title: 'Da li ste sigurni da želite da dodijelite dodatni STB uređaj?',
					submitButton: 'Dodijelite dodatni STB',
				},
				removeModal: {
					title: 'Da li ste sigurni da želite otkazati dodatni STB uređaj?',
					submitButton: 'Otkažite dodatni STB',
				},
				notification: {
					title: 'Vaš zahtjev je poslan.',
					description: 'Očekujte obradu Zahjteva u najkraćem mogućem roku.'
				}
			},
			tvChannels: {
				title: 'Lista kanala',
				position: 'Pozicija - ',
			},
			bills: {
				tabsItemsTitles: ['PREGLED RAČUNA', 'MOJ RAČUN', 'UKLJUČENJE NA RIJEČ', 'PLATI KAO DRUGO LICE'],
				noBillAccountTitle: 'Za izabranog korisnika nema računa za prikaz.'
			},
			billsOverview: {
				description: ['Neizmirene račune možete platiti VISA, MasterCard ili Maestro platnim karticama klikom na dugme Platite račun.', 'Online je moguće platiti samo račune koji nisu izmireni u potpunosti.'],
				downloadBills: 'Svi računi / Preuzmite PDF',
				payedBills: {
					title: 'Hvala Vam što izmirujete obaveze na vreme.',
					description: 'Nemate neizmirenih računa.',
				},
				noBillsTitle: 'Nemate računa za prikaz.',
				statuses: {
					paid: 'Izmiren',
					not_paid: 'Neizmiren',
					partially_paid: 'Djelimično izmiren',
					processing: 'U obradi',
				},
				billsModal: {
					title: 'Pregled vaših računa',
					description: 'Ovde možete vidjeti sve račune u poslednjih 12 mjeseci.',
					billPriceCorrection: 'Korekcija računa',
				},
				downloadTooltip: 'Preuzmite PDF',
				sentToEmailTooltip: 'Pošaljite račun na mejl',
				emailSentNotificationDescription: 'Račun je poslan na vašu e-mail adresu.',
				billButtons: {
					not_paid: {
						button: 'Platite račun',
						tooltip: '',
					},
					partially_paid: {
						button: 'Račun je djelimično izmiren',
						tooltip: 'Online je moguće platiti samo račune koji nisu izmireni u potpunosti. Za pomoć oko plaćanja računa pozovite korisnički centar na 0800 50 000.',
					},
					// todo will be synced with Commerce
					processing: {
						button: 'Račun je u obradi',
						tooltip: 'Potrebno je 24h da se bankarska transakcija obradi. Za pomoć pozovite 0800 50000.',
					},
				},
				noPdfNotificationTitle: 'Nema računa za preuzimanje.',
				activateEBillModal: {
					title: 'Preuzimanje računa',
					description: 'Kako biste bili u mogućnosti da preuzmete račune potrebno je da aktivirate uslugu Moj račun.',
					submitButton: 'Aktivirajte Moj račun',
				}
			},
			eBillsOverview: {
				description: 'Aktivacijom ove usluge račun će Vam stizati na e-mail adresu: {email}. Ostvarujete brži i jednostavniji uvid u svoje mjesečne račune na portalu Moj m:tel. Dostava računa putem e-mail-a isključuje dostavu računa putem pošte.',
				infoTitle: 'Moj račun',
				infoItems: ['Moj račun usluga je besplatna', 'Računi su brže i sigurnije dostavljeni', 'Usluga doprinosi zaštiti životne sredine', 'Jednostavnije je arhivirati račune', 'PDF verzija računa je dostupna u svako doba', 'Račune možete platiti bilo kada'],
				deactivationInfoItems: ['Besplatnu uslugu Moj račun', 'Brže i sigurnije dostavljanje računa', 'Mogućnost plaćanja računa bilo kada', 'Jednostavnije arhiviranje računa', 'PDF verziju računa koja je dostupna u svako doba', 'Uslugu koja doprinosi zaštiti životne sredine'],
				emailLabel: 'E-mail adresa za dostavu računa:',
				ebillButtonLabels: {
					active: 'Deaktivirajte',
					inactive: 'Aktivirajte',
					pending: 'U obradi'
				},
				activationModal: {
					title: 'Da li ste sigurni da želite da aktivirate uslugu Moj račun?',
					description: 'Nakon aktivacije račun će Vam stizati na vašu e-mail adresu {email}.'
				},
				deactivationFirstModal: {
					title: 'Deaktivacijom usluge Moj račun isključujete:',
					description: 'Ukoliko ste sigurni da želite da deaktivirate uslugu Moj račun kliknite na dugme nastavi.'
				},
				deactivationSecondModal: {
					title: 'Da li ste sigurni da želite deaktivirati uslugu Moj račun?',
					description: 'Nakon deaktivacije račun za sljedeći obračunski period će stići na Vašu kućnu adresu. Molimo da prije deaktivacije pozovete 0800 50000 za provjeru tačnosti Vaše adrese.'
				},
				successNotification: {
					title: 'Vaš zahtjev je uspješno poslan.',
					description: 'Očekujte obradu u najkraćem roku.'
				}
			},
			tvToGo: {
				title: 'Tv to GO',
				descriptionCreateAccount: ['Usluga Vam omogućava da pratite omiljene televizijske sadržaje na tabletu ili računaru ili mobilnom telefonu gdje god to poželite.', 'Kako biste aktivirali uslugu, potrebno je da registrujete nalog popunjavanjem forme ispod.', 'Nakon popunjene forme biće Vam poslat e-mail sa aktivacionim linkom koji će važiti u narednih 48 sati.'],
				descriptionAccountExists: 'Usluga Vam omogućava da pratite omiljene televizijske sadržaje na tabletu ili računaru ili mobilnom telefonu gdje god to poželite.',
				descriptionChangePassword: ['Na sekciji ispod možete  promeniti vašu lozinku.', 'Potrebno je da ukucate novu i da je potvrdite.'],
				form: {
					emailLabel: 'E-mail adresa (korisničko ime)',
					emailPlaceholder: 'Unesite e-mail',
					passwordValidationMessage: 'Lozinka mora imati najmanje 6 karaktera.',
					passwordLabel: 'Lozinka',
					newPasswordLabel: 'Nova lozinka',
					passwordPlaceholder: 'Unesite lozinku',
					additionalPasswordInfo: 'Lozinka mora ispuniti uslov od najmanje 6 karaktera',
					repeatPasswordLabel: 'Potvrdi lozinku',
					createAccountButton: 'Kreirajte nalog',
					changePasswordButton: 'Izmjenite lozinku',
				},
				accountExists: {
					title: 'Podaci naloga',
					emailLabel: 'Korisničko ime',
				},
				appsTitle: 'Preuzmite aplikaciju i gledajte TV u pokretu.',
				devicesList: {
					title: 'Lista uređaja',
					activeDevices: 'Aktivni uređaji',
					description: 'Broj uređaja na kojima istovremeno možete gledati TV To GO: {amount}',
					deviceName: 'Naziv uređaja',
					lastVisit: 'Poslednji put ulogovan'
				},
				accountDeletedNotificationDescription: 'Uspješno ste obrisali nalog.',
				deviceDeletedNotificationDescription: 'Uspješno je uklonjen uređaj {deviceName}.',
				deleteAccountModal: {
					title: 'Da li ste sigurni da želite obrisati postojeći nalog?',
					description: 'Novi nalog možete kreirati u svakom trenutku.',
					submitButton: 'Uklonite nalog',
				},
				deleteDeviceModal: {
					title: 'Da li ste sigurni da želite da obrišete uređaj {deviceName}?',
					description: 'Nakon brisanje nećete biti u mogućnosti da gledate sadržaj na tom uređaju.',
					submitButton: 'Uklonite uređaj',
				}
			},
			tvToGoSuccess: {
				title: 'Uspješno ste kreirali TV To Go nalog!',
				description: ['Preuzmite TV To Go Aplikaciju i gledajte svoj omiljeni sadržaj kad god i gdje god to poželite.', 'Prijavite se na moj. mtel. ba i upravljajte vašim TV To Go nalogom.'],
				submitButton: 'Prijavite se',
			},
			iptvAddons: {
				descriptions: {
					iptv: 'Aktivirajte dodatne TV pakete, izaberite dodatne videoteke i uživajte u raznovrsnom TV sadržaju i naprednim TV funkcijama.',
					msat: 'Aktivirajte dodatne TV pakete i uživajte u bogatom TV sadržaju.',
				},
				packageContent: 'Sadržaj paketa',
				activateModal: {
					title: 'Da li ste sigurni da želite da aktivirate paket {addonName}?',
					description: 'Mjesečna naknada za korišćenje paketa iznosi {price} KM.'
				},
				deactivateModal: {
					title: 'Da li ste sigurni da želite deaktivirati {addonName}?',
					descriptionMSAT: 'U mjesecu aktivacije/deaktivacije obračunaće se pun iznos mesečne naknade.',
				},
				addonActivatedNotificationDescription: 'Uspješno ste aktivirali {addonName}.',
				addonDeactivatedNotificationDescription: 'Uspješno ste deaktivirali {addonName}.',
				msatNotificationDescription: 'Očekujte obradu u najkraćem mogućem roku.',
				additionalInfo: 'Navedene pakete/videoteke/usluge je moguće aktivirati/deaktivirati jednom u toku obračunskog perioda. Više o uslovima deaktivacije možete saznati pozivom na 0800 50 905. U mjesecu aktivacije/deaktivacije obračunaće se pun iznos mjesečne naknade.',
			},
			deactivatedService: {
				title: 'Usluga je isključena',
				description: 'Usljed dugovanja usluga je trenutno deaktivirana.',
				buttonText: 'Platite račune',
			},
			fixedOccasionallyDeactivatedService: {
				title: 'Povremeno korištenje',
				description: ['Korisnik ste usluge povremenog korišćenja.', 'Za uključenje Zahtjevane usluge, molimo da kliknete dugme “Aktivirajte uslugu”. Za isključivanje usluge potrebno je da se obratite najbližem m:tel prodajnom mjestu. Za više informacija pozovite 0800 50 000.'],
				buttonText: 'Aktivirajte uslugu',
				successNotification: {
					title: 'Zahtjev je uspješno poslan.',
					description: 'Očekujte obradu u najkraćem roku.'
				}
			},
			dataUpdatedService: {
				title: 'Usluga je isključena',
				description: 'Primećene su promene na vašoj usluzi, molimo vas da ponovo uvežete uslugu.',
				buttonText: 'Uvežite',
			},
			parking: {
				title: 'Parking',
				tabName: 'Plaćanje parkinga',
				description: 'Platite parking brzo i jednostavno gdje god da se nalazite. Dodavanjem nove tablice za svaku možete staviti i opis radi lakšeg snalaženja. Cijene parkiranja su sa PDV-om.',
				addNewCarNumberFieldLabel: 'Dodajte novu tablicu',
				addNewCarNumberPlaceholder: 'Dodajte tablicu automobila',
				chooseCarTitle: 'Odaberite tablicu',
				addNewCarModal: {
					title: 'Unesite broj tablice',
					formNewCarNumberFieldLabel: 'Tablica',
					formNewCarDescriptionFieldLabel: 'Opis',
					submitButton: 'Sačuvajte',
				},
				cityLabel: 'Grad',
				zoneLabel: 'Zona',
				fieldPlaceholder: 'Odaberite',
				payButton: 'Platite',
				carLengthValidation: 'Maksimalan broj karaktera je 20.',
				carSuccessfulAddedNotificationTitle: 'Uspješno dodata tablica.',
				carSuccessfulRemovedNotificationTitle: 'Uspješno uklonjena tablica.',
				removeCarModal: {
					title: 'Da li ste sigurni da želite obrisati tablicu {number} {description}?',
					description: 'Obrisanu tablicu nećete moći više da koristite dok je opet ne dodate.',
					submitButton: 'Potvrdite',
				},
				payParkingModal: {
					title: 'Potvrda plaćanja parkinga',
					submitButton: 'Platite kartu'
				},
				successfullyPaidNotification: {
					title: 'Uspješno plaćeno.',
					description: 'Potvrda za plaćanje će Vam stići SMS-om.'
				}
			},
			listOfApps: {
				title: 'Naše aplikacije',
				learnMoreLink: 'Saznajte više',
				mGo: {
					description: 'Aktiviraj usluge sa m:go aplikacijom.'
				},
				mondo: {
					description: 'Najbrža aplikacija za najbrže vijesti.'
				},
				tvToGo: {
					description: 'Televizija za ponijeti.'
				},
				mPay: {
					description: 'Recite zbogom čekanju u redovima uz najnoviju m:pay aplikaciju.'
				},
				onTv: {
					description: 'Dosada OFF. Zabava ON!'
				}
			},
			apps: {
				overview: 'Pregled',
				userGuide: 'Uputstvo za korišćenje',
				additionalNavItems: ['Pozovite nas', 'Pošaljite nam mejl', 'Posjetite sajt'],
			},
			digitalServices: {
				description: 'Odaberite uslugu koju želite da zadužite.',
				historyTableTitle: 'Istorija kupovine',
				noAddons: {
					title: 'Aplikaciju nije moguće aktivirati na odabranoj usluzi.',
					description: 'Molimo Vas da odaberete drugu uslugu iz padajućeg menija.',
				},
				temporaryFailure: {
					title: 'Usluga trenutno nije dostupna. ',
					description: 'Molimo pokušajte kasnije.',
				}
			},
			sigurannet: {
				title: 'Siguran Net',
				priceTopLabel: 'Prvih 60 dana',
				activeStatus: 'Aktivan',
				historyTableHeader: ['Naziv', 'Datum aktivacije', 'Status'],
				activateAddonModal: {
					title: 'Da li želite aktivirati uslugu Siguran Net?',
					description: 'Usluga se automatski obnavlja svaki mjesec.',
					submitButton: 'Aktivirajte',
				},
				deactivateAddonModal: {
					title: 'Da li ste sigurni da želite da deaktivirate  uslugu Siguran Net?',
					submitButton: 'Deaktivirajte',
				},
				successfulDeactivatedNotification: {
					titleMobileService: 'Vaš zahtjev je prihvaćen. Usluga će biti deaktivirana na kraju mjeseca.',
					titleFixedService: 'Vaš zahtjev je prihvaćen. Uspješno ste deaktivirali tarifnu opciju.',
				},
				userPortal: {
					title: 'Korisnički portal',
					description: 'Kontrola sadržaja i podešavanja',
					tooltip: 'Na korisničkom portalu omogućeno vam je filtriranje sadržaja i\n' +
						'podešavanja pristupa internet stranicama, ali i detaljan prikaz\n' +
						'statistike zaštite od malicioznih sadržaja.',
					note: 'Usluga se automatski obnavlja svaki mjesec.'
				}
			},
			apollon: {
				title: 'Apollon',
				historyTableHeader: ['Naziv', 'Datum aktivacije', 'Status'],
				activateAddonModal: {
					title: 'Da li ste sigurni da želite aktivirati Apollon?',
					description: 'Usluga se automatski obnavlja svakog mjeseca.',
					submitButton: 'Aktivirajte',
				},
				successfulActivatedModal: {
					title: 'Uspješno ste kupili Apollon',
					description: 'Za korišćenje usluge potrebno je da se registrujete Moj m:tel nalogom na Apollon aplikaciju.',
				},
				deactivateAddonModal: {
					title: 'Da li ste sigurni da želite deaktivirati Apollon?',
					description: 'Nakon podnešenog zahtjeva za deaktivaciju, usluga ostaje aktivna do kraja tekućeg mjeseca ili 30 dana od dana aktivacije putem Dopuna broja.',
					submitButton: 'Deaktivirajte',
				},
				successfulDeactivatedNotification: {
					title: 'Apollon je deaktiviran',
					description: 'Uslugu možete koristiti do kraja tekućeg mjeseca ili 30 dana od dana aktivacije putem Dopuna broja.'
				}
			},
			arenacloud: {
				title: 'Arena Cloud',
				labelName: 'Jednom mjesečno možete promjeniti paket',
				historyTableHeader: ['Naziv', 'Datum aktivacije', 'Status'],
				activateAddonModal: {
					title: 'Da li ste sigurni da želite aktivirati Arena Cloud {addonName}?',
					description: 'Usluga se automatski obnavlja svakog mjeseca.',
					submitButton: 'Aktivirajte',
				},
				successfulActivatedModal: {
					title: 'Uspješno ste kupili Arena Cloud {addonName}',
					description: 'Za korišćenje usluge potrebno je da se registrujete Moj m:tel nalogom na Arena Cloud aplikaciji.',
				},
				deactivateAddonModal: {
					title: 'Da li ste sigurni da želite deaktivirati Arena Cloud {addonName}?',
					description: 'Nakon podnešenog zahtjeva za deaktivaciju, usluga ostaje aktivna do kraja tekućeg mjeseca ili 30 dana od dana aktivacije putem Dopuna broja.',
					submitButton: 'Deaktivirajte',
				},
				changeAddon: {
					title: 'Da li ste sigurni da želite da promjenite paket u Arena Cloud {addonName}?',
					description: ['Promjena Arena Cloud paketa se realizuje odmah.','Za korišćenje usluge Arena Cloud u mjesecu u kojem je izvršena promjena Arena Cloud paketa, naplata se vrši za oba Arena Cloud paketa i to proporcionalno broju dana korišćenja svakog Arena Cloud paketa u tom obračunskom mjesecu.', 'U toku mjeseca imate pravo na jednu promjenu paketa.'],
					submitButton: 'Aktivirajte',
				},
				successfulDeactivatedNotification: {
					title: 'Arena Cloud je deaktivirana.',
					description: 'Uslugu možete koristiti do kraja tekućeg mjeseca ili 30 dana od dana aktivacije putem Dopuna broja.'
				},
				packageActivatedNotification: {
					description: 'Očekujte obradu u narednih nekoliko minuta.'
				}
			},
			balkan: {
				title: 'Balkan Myusic',
				historyTableHeader: ['Naziv', 'Datum aktivacije', 'Status'],
				activateAddonModal: {
					title: 'Da li ste sigurni da želite aktivirati Balkan Myusic?',
					description: 'Usluga se automatski obnavlja svakog mjeseca.',
					submitButton: 'Aktivirajte',
				},
				successfulActivatedModal: {
					title: 'Uspješno ste kupili Balkan Myusic',
					description: 'Za korišćenje usluge potrebno je da se registrujete Moj m:tel nalogom na Balkan Myusic aplikaciju.',
				},
				deactivateAddonModal: {
					title: 'Da li ste sigurni da želite deaktivirati Balkan Myusic?',
					description: 'Nakon podnešenog zahtjeva za deaktivaciju, usluga ostaje aktivna do kraja tekućeg mjeseca ili 30 dana od dana aktivacije putem Dopuna broja.',
					submitButton: 'Deaktivirajte',
				},
				successfulDeactivatedNotification: {
					title: 'Balkan Myusic je deaktiviran.',
					description: 'Uslugu možete koristiti do kraja tekućeg mjeseca ili 30 dana od dana aktivacije putem Dopuna broja.'
				},
			},
			deezer: {
				title: 'Deezer',
				historyTableHeader: ['Naziv', 'Datum aktivacije', 'Status', 'Aktivacioni link'],
				priceTopLabel: 'Prvih mjesec dana',
				link: 'Link',
				promoCodeLabel: 'Aktivacioni link',
				promoCodeValue: 'deezer link',
				copyCode: 'Kopiraj link',
				codeCopied: 'Link kopiran',
				activateAddonModal: {
					title: 'Da li ste sigurni da želite aktivirati Deezer?',
					description: 'Usluga se automatski obnavlja svakog mjeseca.',
					submitButton: 'Aktivirajte',
				},
				successfulActivatedModal: {
					title: 'Uspješno ste kupili Deezer',
					description: 'Za korišćenje Deezer-a potrebno je da se registrujete putem Deezer aplikacije/portala uz korišćenje aktivacionog linka.',
				},
				deactivateAddonModal: {
					title: 'Da li ste sigurni da želite deaktivirati Deezer?',
					description: 'Nakon podnešenog zahtjeva za deaktivaciju, usluga ostaje aktivna do kraja tekućeg mjeseca ili 30 dana od dana aktivacije putem Dopuna broja.',
					submitButton: 'Deaktivirajte',
				},
				successfulDeactivatedNotification: {
					title: 'Deezer je deaktiviran.',
					description: 'Uslugu možete koristiti do kraja tekućeg mjeseca ili 30 dana od dana aktivacije putem Dopuna broja.'
				},
			},
			nba: {
				title: 'NBA',
				buyCode: 'Kupite kod',
				bestChoice: 'Najbolji izbor',
				historyTableHeader: ['Naziv', 'Datum kupovine koda', 'Kod'],
				free: 'Besplatno',
				promoCodeLabel: 'Promo kod',
				copyCode: 'Kopiraj kod',
				codeCopied: 'Kod kopiran',
				addonsAdditionalInfo: 'Ukoliko vaš tarifni model ima uključen besplatni {addonName}, možete ga aktivirati jednom mjesečno bez dodatnih troškova.',
				activateAddonModal: {
					title: 'Da li ste sigurni da želite kupiti kod za {addonName}?',
					description: 'Kupljeni kod za {addonName} možete aktivirati bilo kada u toku NBA sezone.',
					submitButton: 'Kupite kod',
				},
				successfulActivatedModal: {
					title: 'Uspješno ste kupili kod',
					description: 'Da biste koristili uslugu potrebno je da se registrujete na NBA servis putem aplikacije ili web portala i unesete kupljeni kod.',
				},
			},
			mtelStore: {
				title: 'm:tel store',
				pageTitle: 'Ponude za Vas'
			},
			tariff: {
				characteristics: {
					showMoreText: 'Šta još dobijaš u tarifi?',
				}
			},
			activationOnWord: {
				activationModal: {
					title: 'Da li ste sigurni da želite da aktivirate uslugu Uključenje na riječ?',
					description: 'Nakon aktivacije usluge uključenja na riječ, a ukoliko u toku od tri dana račun ne bude izmiren, nećete biti u mogućnosti da je ponovo koristite u narednih 6 mjeseci.'
				},
				buttonLabels: {
					ACTIVE: 'Aktivirajte',
					PROCESSING: 'Uključenje je u toku',
					TEMPORARY_BARRING: 'Aktivirajte'
				},
				paidStatus: 'Svi računi su plaćeni. Hvala što na vrijeme izmirujete svoje obaveze.',
				description: 'Zaboravili ste da na vrijeme izmirite svoje mjesečne obaveze za telekomunikacione usluge? Ne brinite, putem usluge “Uključenje na riječ” možete izvršiti uključenje, bez čekanja na evidentiranje uplate. U slučaju da u roku od 3 dana nakon aktivacije usluge ne izmirite svoje račune nećete moći koristiti ovu uslugu narednih 6 mjeseci.'
			},
			appSnackbar: {
				altLogo: 'Moj m:tel logo',
				title: 'Moj m:tel',
				description: 'Za još bolje korisničko iskustvo preuzimte aplikaciju',
				btnText: 'Preuzmi'
			},
			personalOffer: {
				prepaid2Postpaid: 'Pređi na pretplatu',
				topup: 'Dopuni se',
				sendRequestButton: 'Pošaljite upit',
				activateAddonModal: {
					title: 'Da li ste sigurni da želite aktivirati ponudu {addonName}?',
				},
				successPre2PostModal: {
					title: 'Hvala Vam na interesovanju!',
					description: 'Uskoro će Vam se javiti m:tel agent prodaje za sve detalje posebne ponude za Vas!',
				},
				successNotification: {
					title: 'Vaš zahtjev je prihvaćen.',
					description: 'Uspješno ste aktivirali ponudu.'
				},
				pendingButton: 'Upit uspješno poslan',
				noOffers: {
					title: 'Personalizovana ponuda trenutno nije dostupna za Vas.',
					description: 'Molimo provjerite kasnije.',
				}
			},
			support: {
				submitRequest: 'Podnesite zahtjev',
				complaints: 'Uložite prigovor',
				incidentReport: 'Prijavite smetnju',
				selectTypeTitle: 'Odaberite uslugu',
				formContactPhone: 'Kontakt telefon',
				historyTitle: 'istorija',
			},
			request: {
				title: 'Online zahtjevi',
				selectContractLabel: 'Odaberite uslugu za koju želite da podnesete zahtjev.',
				selectRequestTypeTitle: 'Izaberite tip zahtjeva',
				selectSubcategoryPlaceholder: 'Izaberite tip usluge',
				formDescription: 'Komentar',
				formSubmitButton: 'Podnesite zahtjev',
				subcategoryFirstWord: 'Želim',
				sendRequestModal: {
					title: 'Da li ste sigurni da želite da podnesete zahtjev za {type}?',
					button: 'Podnesite zahtjev',
				}
			},
			complaint: {
				title: 'Prigovori',
				selectContractLabel: 'Odaberite uslugu za koju želite da podnesete prigovor.',
				selectRequestTypeTitle: 'Izaberite tip prigovora',
				formDescription: 'Komentar',
				formSubmitButton: 'Uložite prigovor',
				billNumberPlaceholder: 'Odaberite broj računa',
				noBills: 'Nema računa',
				fieldPlaceholders: {
					complaint_2_equipment: 'Serijski broj',
					complaint_3_contract: 'Broj ugovora',
				},
				sendRequestModal: {
					title: 'Da li ste sigurni da želite da uložite {type}?',
					button: 'Uložite prigovor',
				},
				additionalInfo: {
					complaint_1_quality: 'Podnesite prigovor na kvalitet izvršene usluge koji će se rješavati u skladu sa Opštim uslovima za pružanje telekomunikacionih usluga koji su dostupni na {url} i u Mtel poslovnim jedinicama.',
					complaint_2_equipment: 'Podnesite prigovor na ispravnost korisničke terminalne opreme u toku trajanja garantnog perioda u skladu sa uslovima Garancije koji će se rješavati u skladu sa Opštim uslovima za pružanje telekomunikacionih usluga koji su dostupni korisnicima na {url} i u Mtel poslovnim jedinicama.',
					complaint_3_contract: 'Podnesite prigovor na povredu odredbi pretplatničkog ugovora koji će se rješavati u skladu sa Opštim uslovima za pružanje telekomunikacionih usluga koji su dostupni na {url} i u Mtel poslovnim jedinicama.',
					complaint_4_bill: 'Podnesite prigovor na račun/obračun za izvršenu uslugu u roku od 30 dana od dana fakturisanja usluge. Ukoliko prigovor nije podnesen u navedenom roku, račun se smatra prihvaćenim. Korisnik koji je podnio prigovor na iznos računa do rješenja prigovora plaća nesporni dio iznosa računa na koji se odnosi podneseni prigovor. U slučaju neplaćanja nespornog djela računa, m:tel ima pravo privremeno isključiti pretplatničku terminalnu opremu/privremeno prekinuti pružanje usluge.'
				}
			},
			incident: {
				title: 'Prijavite smetnju',
				selectContractLabel: 'Odaberite uslugu za koju želite da prijavite smetnju.',
				selectSubcategoryPlaceholder: 'Izaberite tip smetnje',
				formDescription: 'Opis smetnje',
				formSubmitButton: 'Prijavite smetnju',
				successNotification: {
					title: 'Vaš zahtjev je uspješno poslan.',
					description: 'M:tel agent će Vas uskoro kontaktirali.',
				},
				sendRequestModal: {
					title: 'Da li ste sigurni da želite da prijavite smetnju?',
					button: 'Prijavite smetnju',
				},
			},
			notifications: {
				title: 'Obavještenja',
				learnMore: 'Saznajte više',
				resetAll: 'Poništite',
				removeAll: 'Obrišite',
				noNotifications: 'Trenutno nemate novih obavještenja',
				successNotification: {
					description: 'Uspješno ste obrisali poruku/e.'
				},
			},
			unpaidBillsOverviewModal: {
				title: 'NEIZMIRENI RAČUNI',
				description: ['Trenutno imate neplaćene račune. Iskoristite mogućnost online plaćanja.', 'VISA/MasterCard/Maestro platnim karticama i platite račune bez provizije.'],
				submitButton: 'Platite račun',
			},
		}
	}
};
